export const validatePhoneNumber = (phoneNumber, invalidMessage) => {
  //phoneNumber is not required
  if (phoneNumber === "") {
    return "";
  }

  const isValidNumber = RegExp(/^[+]?[(]?[0-9]{3}[)]?[-\s.]?[0-9]{3}[-\s.]?[0-9]{4}$/).test(phoneNumber);
  if (!isValidNumber) {
    return invalidMessage;
  }

  return "";
};

export const validateFtPt = (ftpt) => {
  //ftpt is required
  if (!ftpt) {
    return "FT/PT is required";
  }

  return "";
};

export const validateDate = (field, value) => {
  //date is required
  if (!value) {
    return `${field} is required`;
  }

  return "";
};
